import { Component, OnInit } from '@angular/core';
import { SentryDataCapture } from './shared/services/sentry/sentry-data-capture.service';
import { AnalyticsService } from './shared/services/analytics.service';
import { AppStore } from './store/store.model';
import { Store } from '@ngrx/store';
import { isAdmin } from './store/user/user.selectors';
import { map } from 'rxjs/operators';
import { AuthLegacyService } from './store/user/auth-legacy.service';
import { RouteAnalyticsService } from './shared/services/route-analytics.service';
import { PosthogService } from './shared/services/posthog.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  public isAdmin$ = this.store.select(isAdmin);
  public showEasterEgg$ = this.isAdmin$.pipe(
    map((isAdminUser) => {
      const today = new Date();
      return isAdminUser && today.getDate() === 1 && today.getMonth() === 3;
    }),
  );

  constructor(
    private store: Store<AppStore>,
    private sentryData: SentryDataCapture,
    private analytics: AnalyticsService,
    private posthog: PosthogService,
    private routeAnalytics: RouteAnalyticsService,
    public auth: AuthLegacyService,
  ) {}

  public ngOnInit() {
    this.sentryData.start();
    this.analytics.startTracking();
    this.posthog.startTracking();
    this.routeAnalytics.initialize();
    this.auth.observeEvents();
  }
}
